import {
  useBooleanFlagValue,
  useNumberFlagValue,
  useStringFlagValue,
} from '@openfeature/react-sdk';

import type { BooleanFlagKey, NumberFlagKey, StringFlagKey } from '../keys';

export const useBooleanFlag = (key: BooleanFlagKey, defaultValue: boolean): boolean =>
  useBooleanFlagValue(key, defaultValue);

export const useStringFlag = (key: StringFlagKey, defaultValue: string): string =>
  useStringFlagValue(key, defaultValue);

export const useNumberFlag = (key: NumberFlagKey, defaultValue: number): number =>
  useNumberFlagValue(key, defaultValue);
